import React from 'react';

import Button from '../../../Components/button';

const ContentSection: React.FC<{content: string, title: string, buttons: Array<{ text: string, link: string }>}> = ({content, title, buttons}) => {
    
    return (
        <section className='pt-4 pb-12 md:-mt-8'>
            <div className="max-w-screen-lg mx-auto px-4">
                <div className="grid items-center gap-8 pt-8">
                    <div>
                        <h3 className="text-2xl font-semibold" dangerouslySetInnerHTML={{ __html: title }} />

                        <div className="mt-4 text-sm 2xl:text-base" dangerouslySetInnerHTML={{ __html: content }} />

                        <div className="flex gap-4 flex-wrap w-full mt-10">
                            {buttons &&
                                buttons.map((button, index) => (
                                    <div key={index} className="max-w-64 w-full">
                                        <Button target='_blank' text={button.text} link={button.link} arrow={false} color="pink" />
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContentSection;